var React = require('react');

function BlueCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"score-gradient","x1":"112.216","y1":"43.3031","x2":"8.78426","y2":"77.6971","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#359FEB","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#0E70E8","key":1})])),React.createElement("circle",{"cx":"60","cy":"60","fill":"transparent","r":"54.5","stroke":"url(#score-gradient)","strokeLinecap":"round","strokeWidth":"10","key":1})]);
}

BlueCircle.defaultProps = {"width":"120","height":"120","viewBox":"0 0 120 120","fill":"none"};

module.exports = BlueCircle;

BlueCircle.default = BlueCircle;
